<template>
  <require from="framework/html_behaviors/bs-tooltip"></require>

  <div class="deviation-request-create-selector --${ kind } ${ disabled ? '--disabled' : ''}" click.delegate="showOptions = !showOptions">
    <div class="deviation-request-create-selector__box d-flex">
      <i class="deviation-request-create-selector__icon fas fa-plus"></i>
      <div class="deviation-request-create-selector__text">
        <h6>${ headerText }</h6>
        <span class="deviation-request-create-selector__description" innerhtml.bind="description"></span>
      </div>
      <i show.bind="!disabled" class="deviation-request-create-selector__chevron fas ${ showOptions ? 'fa-chevron-up' : 'fa-chevron-down' }"></i>
    </div>
  </div>
  <div class="deviation-request-create-options">
    <ul show.bind="showOptions">
      <li repeat.for="item of items">
        <span click.delegate="item.onClick()" title.bind="item.info"><i class="item-icon ${item.icon}"></i>${ item.name }</span>
        <span click.delegate="deviationRequestCreateSelectorTooltip.show()" class="info-icon" show.bind="item.info" title="${item.info}" bs-tooltip bs-tooltip.ref="deviationRequestCreateSelectorTooltip"><i class="fas fa-info-circle"></i></span>
      </li>
    </ul>
  </div>
</template>
